import { useState } from 'react';

const useFilters = (initialValue) => {
  const [filters, setFilters] = useState(initialValue || {});

  const handleSetFilters = (filter) =>
    setFilters((prevState) => ({ ...prevState, ...filter }));

  const setFilter = (name) => (filter) => handleSetFilters({ [name]: filter });

  return {
    filters,
    setFilter,
    addFilters: handleSetFilters,
  };
};

export default useFilters;
